"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Span = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  & > * {\n    display: block;\n  }\n"], ["\n  ",
    "\n  & > * {\n    display: block;\n  }\n"])), function (_a) {
    var isWithPosition = _a.isWithPosition;
    return isWithPosition && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: absolute !important;\n      overflow: hidden;\n      z-index: 10;\n      margin: 16px 0 0 -38px;\n    "], ["\n      position: absolute !important;\n      overflow: hidden;\n      z-index: 10;\n      margin: 16px 0 0 -38px;\n    "])));
});
var LoupeIcon = function (_a) {
    var isWithPosition = _a.isWithPosition;
    return (react_1.default.createElement(Span, { isWithPosition: isWithPosition },
        react_1.default.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6499 14.036C11.322 15.0682 9.65352 15.6829 7.84145 15.6829C3.51074 15.6829 0 12.1722 0 7.84145C0 3.51074 3.51074 0 7.84145 0C12.1722 0 15.6829 3.51074 15.6829 7.84145C15.6829 9.65352 15.0682 11.322 14.036 12.6499L18 16.6138L16.6138 18L12.6499 14.036ZM13.7225 7.84145C13.7225 11.0895 11.0895 13.7225 7.84145 13.7225C4.59341 13.7225 1.96036 11.0895 1.96036 7.84145C1.96036 4.59341 4.59341 1.96036 7.84145 1.96036C11.0895 1.96036 13.7225 4.59341 13.7225 7.84145Z", fill: "#2362A2" }))));
};
LoupeIcon.defaultProps = {
    isWithPosition: undefined,
};
exports.default = LoupeIcon;
var templateObject_1, templateObject_2;
